import { OrderType } from '~/types/common';
import { OrderStatus } from '~/types/order';
import { platformPickupPointMapString } from '~/pages/OrderList/orderTypeMapString';

import * as fp from 'lodash/fp';

export type ProgressStatusInfo = {
  status: OrderStatus;
  label: string;
};

// OrderType.PLATFORM_PICKUP_POINT
export const platformPickupPointProgress: Array<ProgressStatusInfo> = [
  {
    status: OrderStatus.DISTRIBUTED,
    label: platformPickupPointMapString[OrderStatus.DISTRIBUTED],
  },
  {
    status: OrderStatus.CREATED,
    label: platformPickupPointMapString[OrderStatus.CREATED],
  },
  {
    status: OrderStatus.ACCEPTED,
    label: platformPickupPointMapString[OrderStatus.ACCEPTED],
  },
  {
    status: OrderStatus.PICKED,
    label: platformPickupPointMapString[OrderStatus.PICKED],
  },
  {
    status: OrderStatus.DELIVERED,
    label: platformPickupPointMapString[OrderStatus.DELIVERED],
  },
  {
    status: OrderStatus.COMPLETED,
    label: platformPickupPointMapString[OrderStatus.COMPLETED],
  },
];

const getOrderTypeProgress = fp.cond<OrderType, Array<ProgressStatusInfo>>([
  [fp.eq(OrderType.PLATFORM_PICKUP_POINT), fp.always(platformPickupPointProgress)],
  [fp.T, fp.always([])],
]);

export default getOrderTypeProgress;
